import AbstractController from '../../../../../../ig_template/Resources/Public/Src/Js/Controller/AbstractController';
import Controller from '../../../../../../ig_template/Resources/Public/Src/Js/Controller/Controller';
import StoresSearch from '../Elements/StoresSearch';

/**
 * Stores Controller
 *
 * @class
 */
class StoresController extends AbstractController {
	/**
	 * @constructor
	 */
	constructor() {
		super();

		Controller.registerController(this);
		this._registerElements(StoresSearch);
	}
}

export default (new StoresController);
